import { SparklesIcon } from '@heroicons/react/24/outline';

type SystemComparisonSummaryProps = Readonly<{
  summary: string | undefined;
  isLoading: boolean;
  hasError: boolean;
}>;

function SummaryBody({
  summary,
  isLoading,
  hasError
}: SystemComparisonSummaryProps) {
  if (isLoading) {
    return (
      <div className='flex animate-pulse flex-col gap-1.5'>
        <div className='h-2.5 rounded bg-gray-200' />
        <div className='h-2.5 rounded bg-gray-200' />
        <div className='h-2.5 w-2/3 rounded bg-gray-200' />
      </div>
    );
  }

  if (hasError) {
    return (
      <p className='text-xs text-gray-400'>
        Unable to generate a comparison right now.
      </p>
    );
  }

  if (!summary) {
    return (
      <p className='text-xs text-gray-400'>
        Add another system to compare to see how this option stacks up.
      </p>
    );
  }

  return <p className='text-sm leading-relaxed text-gray-700'>{summary}</p>;
}

export default function SystemComparisonSummary({
  summary,
  isLoading,
  hasError
}: SystemComparisonSummaryProps) {
  return (
    <div className='rounded-lg border border-gray-200 bg-white p-3'>
      <div className='mb-2 flex items-center gap-1.5'>
        <SparklesIcon className='h-3.5 w-3.5 shrink-0 text-purple-500' />
        <span className='text-[10px] font-semibold uppercase tracking-wider text-gray-500'>
          Why This System
        </span>
      </div>
      <SummaryBody
        summary={summary}
        isLoading={isLoading}
        hasError={hasError}
      />
    </div>
  );
}
